const plugin = {
  install(Vue, options) {
    // Default options
    const Locale = options.locale || 'en'; // eslint-disable-line no-unused-vars
    const fallbackLocale = options.fallback || 'en'; // eslint-disable-line no-unused-vars
    const messages = options.messages || {}; // eslint-disable-line no-unused-vars

    const lang = window.Lang;

    Object.defineProperty(Vue.prototype, '$lang', {
      get() { return this.$root._lang; }, // eslint-disable-line no-underscore-dangle
    });

    Vue.mixin({
      beforeCreate() {
        Vue.util.defineReactive(this, '_lang', lang);
      },
      methods: {
        trans(key) {
          lang.setLocale(Locale);
          lang.setFallback(fallbackLocale);
          return lang.get(key);
        },
      },
    });
  },
};

export default plugin;
